import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ColumnItemPlaceholder from './ColumnItemPlaceholder/ColumnItemPlaceholder';
import ColumnItemImportPlaceholder from './ColumnItemPlaceholder/ColumnItemImportPlaceholder';
import ColumnItemContainer from './ColumnItemContainer';
import * as Styled from './styles';
import { elementType } from '../../../../../types';

class ColumnItems extends PureComponent {
    render() {
        const { blockIndex, columnIdx, structureLocked, columnItems, width, selectedElements, canvasBlocks, dispatch } =
            this.props;

        if (columnItems.length === 0) {
            const block = canvasBlocks.filter((b) => b.index === blockIndex)[0];
            return (
                <div style={{ display: 'block' }}>
                    {block.title === 'Staffbase News' ? (
                        <ColumnItemImportPlaceholder
                            blockIndex={blockIndex}
                            columnIdx={columnIdx}
                            dispatch={dispatch}
                        />
                    ) : (
                        <ColumnItemPlaceholder blockIndex={blockIndex} columnIdx={columnIdx} dispatch={dispatch} />
                    )}
                </div>
            );
        }

        return (
            <div>
                {columnItems.map((columnItem) => {
                    const { elmIdx, type, content } = columnItem;
                    const selectedElement = selectedElements.local[elmIdx] || selectedElements.remote[elmIdx] || {};
                    const isRemoteSelected = !!selectedElement.remote;
                    const remoteUser = selectedElement.remote;
                    return (
                        <div
                            key={elmIdx}
                            style={{
                                display: 'block',
                                position: 'relative',
                            }}
                        >
                            <Styled.Div />
                            <ColumnItemContainer
                                blockIndex={blockIndex}
                                columnIdx={columnIdx}
                                structureLocked={structureLocked}
                                numElements={columnItems.length}
                                elmIdx={elmIdx}
                                content={content}
                                type={type}
                                isRemoteSelected={isRemoteSelected}
                                user={remoteUser}
                                width={width}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedElements: state.selectedElements,
    canvasBlocks: state.canvasBlocks.present,
});

ColumnItems.propTypes = {
    blockIndex: PropTypes.string.isRequired,
    columnIdx: PropTypes.string.isRequired,
    columnItems: PropTypes.arrayOf(elementType).isRequired,
    structureLocked: PropTypes.bool.isRequired,
    width: PropTypes.number.isRequired,
    selectedElements: PropTypes.object.isRequired,
    canvasBlocks: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(ColumnItems);
